"use client"

import { useEffect, useMemo, useState } from "react"
import { useTheme } from "next-themes"
import { Button } from "@/components/ui/button"
import { Moon, Sun } from "lucide-react"

export default function ThemeToggle() {
  const { theme, resolvedTheme, setTheme } = useTheme()
  const [mounted] = useState<boolean>(() => typeof window !== 'undefined')

  const effectiveTheme = useMemo(() => {
    if (!mounted) return undefined
    if (theme === "system") return resolvedTheme ?? "light"
    return theme
  }, [theme, resolvedTheme, mounted])

  const toggle = () => {
    const next = effectiveTheme === "dark" ? "light" : "dark"
    setTheme(next as any)
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label="Toggle theme"
      onClick={toggle}
      className="h-8 w-8"
    >
      {effectiveTheme === "dark" ? (
        <Sun className="h-4 w-4" />
      ) : (
        <Moon className="h-4 w-4" />
      )}
      <span className="sr-only">Toggle theme</span>
    </Button>
  )
}

